import moment from "moment";

const formatDuration = (ms: number): string => {
  const d = moment.duration(ms);
  const minutes = Math.floor(d.asMinutes());
  const hours = Math.floor(d.asHours());
  const days = Math.floor(d.asDays());
  if (days >= 1) return `${days} day${days === 1 ? "" : "s"}`;
  if (hours >= 1) return `${hours} hour${hours === 1 ? "" : "s"}`;
  if (minutes >= 1) return `${minutes} minute${minutes === 1 ? "" : "s"}`;
  return "less than a minute";
};

export const formatTimeAgo = (iso: string | undefined | null): string => {
  if (!iso) return "";
  const m = moment(iso);
  if (!m.isValid()) return "";
  const diffMs = moment().valueOf() - m.valueOf();
  return `${formatDuration(diffMs)} ago`;
};

export const formatTimeUntilOrAgo = (
  iso: string | undefined | null
): { text: string; isPast: boolean } => {
  if (!iso) return { text: "", isPast: false };
  const m = moment(iso);
  if (!m.isValid()) return { text: "", isPast: false };
  const diffMs = m.valueOf() - moment().valueOf();
  if (diffMs >= 0) return { text: formatDuration(diffMs), isPast: false };
  return { text: formatDuration(-diffMs), isPast: true };
};

export const formatIsoToLocal = (iso: string | undefined | null): string => {
  if (!iso) return "";
  const m = moment(iso);
  return m.isValid() ? m.local().format("MM/DD/YY h:mm A") : "";
};

export const formatDateString = (date: string | undefined | null): string => {
  if (!date) return "";
  const m = moment(date, "YYYY-MM-DD");
  return m.isValid() ? m.format("MM/DD/YY") : "";
};
